<template>
  <div>

    <v-card-title class="text-h4 font-weight-bold mb-4">
      {{ $t("account.whitelabel.title") }}
    </v-card-title>
    <v-card color="" elevation="0" class="">
      <v-divider></v-divider>
      <template>
        <v-tabs
          color="primary"
          v-model="tabs"
          class=""
          height="40"
          background-color="#f4f4f4"
        >
          <v-tab class="ml-4"> {{ $t("account.whitelabel.data.title") }}</v-tab>
          <v-tab> {{ $t("account.whitelabel.resource.title") }}</v-tab>
          <v-tab disabled>MarketPlace</v-tab>

          <!-- <v-tab disabled>{{ $t('products.ASUS.prices') }}</v-tab>
            <v-chip x-small class="mb-2 mt-2 px-1 ml-n3" color="info"><span class="black---text">{{ $t('products.ASUS.underDev') }}</span></v-chip>
            <v-tab disabled>{{ $t('products.ASUS.ratings') }}</v-tab>
            <v-chip x-small class="mb-2 mt-2 px-1 ml-n3" color="info"><span class="black---text">{{ $t('products.ASUS.underDev') }}</span></v-chip> -->
        </v-tabs>
      </template>
      <v-divider></v-divider>

      <v-tabs-items v-model="tabs">
        <v-tab-item>
          <AccountData :currentPlan="currentPlan" :currentCicle="currentCicle" @update-doc="doc = $event"></AccountData>
        </v-tab-item>
        <v-tab-item>
          <ResourceControl
          @change-period="period = $event"
          @plan-signed="planSigned = $event"
            :orders="orders"
            :doc="doc"
            :allPlans="allPlans"
            :currentPlan="currentPlan"
            :currentCicle="currentCicle"
            :statsInfo="statsInfo"
            :loadingPlans="loadingPlans"
          ></ResourceControl>
        </v-tab-item>
        <v-tab-item><MarketPlace/> </v-tab-item>
        <v-tab-item></v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
// import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import moment from "moment"
import config from "@/store/config";
import { mapState } from "vuex";
import AccountData from "@/components/account/whitelabel/AccountData";
import ResourceControl from "@/components/account/whitelabel/ResourceControl";
import MarketPlace from "@/components/account/whitelabel/MarketPlace";
import { initializeApp } from "firebase/app";
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";

export default {
  name: "AccountView",
  components: {
    AccountData,
    ResourceControl,
    MarketPlace,
  },
  data() {
    return {
      doc: false,
      planSigned : false,
      loadingPlans: false,
      period: 12,
      tabs: 0,
      allPlans: [],
      signaturePlan: [],
      currentPlan: {},
      currentCicle: {},
      orders: [],
      loading: true,
      statsInfo:{},
    };
  },

  computed: {
    ...mapState("groupStores", ["selectedStore"]),

    loadingType() {
      return ["xs", "sm"].includes(this.$vuetify.breakpoint.name)
        ? "card"
        : "card";
    },

    // activeOrders() {
    //   const planFromDate = moment(this.activePlan.from, "YYYY-MM-DD");
    //   const planToDate = moment(this.activePlan.to, "YYYY-MM-DD");
    //   const result = this.orders.filter((order) => {
    //     if (["paid", "wiating_upload"].includes(order.status)) {
    //       const orderData = moment(order.createdOn, "YYYY-MM-DD HH:mm:ss");
    //       if (
    //         orderData.isBetween(
    //           planFromDate.format("YYYY-MM-DD"),
    //           planToDate.format("YYYY-MM-DD")
    //         )
    //       ) {
    //         return order;
    //       }
    //     }
    //   });
    //   return result;
    // },
  },
  created() {},



  async mounted() {
    await this.loadOrders();
    this.getAllPlans();
    await this.getCurrentPlan();
    await  this.getUniqueVisitors()
    this.loadTabs();
  },
  watch: {
    "$route.params.tab"() {
      this.loadTabs();
    },
    planSigned(nv){
      if(nv === true){
        console.log('nv',nv)
        this.getCurrentPlan()
      }
    },
    period(){
      this.getAllPlans()
    },
    tabs(nV) {
      let query = [];
      for (let key in this.$route.query) {
        if (nV != 0 && key == "q")
          query.push(`${key}=${this.$route.query[key]}`);
      }
      const qstring = query.length ? `?${query.join("&")}` : "";

      if (nV == 0 && this.$route.path != "/account/whitelabel/data")
        this.$router.replace(`/account/whitelabel/data${qstring}`);
      if (nV == 1 && this.$route.path != "/account/whitelabel/resource")
        this.$router.replace(`/account/whitelabel/resource${qstring}`);
    },
  },
  methods: {
    loadOrders() {
      if(config){
      // Initialize Firebase
      const firebase = initializeApp(config);
      const db = getFirestore(firebase);
      const q = query(collection(db, "orders"));
      const querySnapshot = getDocs(q);
      const orders = [];
      querySnapshot.then((docs) => {
        docs.forEach((doc) => {
          orders.push(doc.data());
        });
        // this.loading = false
        this.orders = orders;
      });
    }
    },

    getAllPlans() {
      this.loadingPlans = true
      let locale = 'BRA'
      if(['Peru', 'PER'].includes(this.$root.auth.whitelabel.country)){
        locale = 'PER'
      }
      const url = `whitelabel/plans?pp=10&pg=1&locale=${locale}&status=1&period=${this.period}`;
      this.$axios
        .get(url)
        .then((response) => {
          console.log('resonse', response.data.data)
          this.allPlans = response.data.data.result.sort((p1, p2) => (p1.name > p2.name) ? 1 : (p1.name < p2.name) ? -1 : 0);
          this.loadingPlans = false
        })
        .catch((error) => {
          console.log(error);
          this.loadingPlans = false
        });
    },
   async getCurrentPlan() {

      const url = `whitelabel/signature`;
     await this.$axios
        .get(url)
        .then((response) => {
          if(response.data.data){
          console.log('allPnas', this.allPlans)
           const currentCicle =  response.data.data;
          this.currentCicle = currentCicle;
          this.currentPlan = response.data.data._plan ? response.data.data._plan : {};
          //console.log("curerntCicle", currentCicle, typeof currentCicle);
          console.log("currentPlan", this.currentPlan);
        }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getUniqueVisitors() {
      const domains = {
          from: moment().subtract(30, 'days').format("YYYY-MM-DD"),
          to: moment().format("YYYY-MM-DD"),
          domains: [`${this.selectedStore.url}.themediatrade.com`],
        };
      if(this.currentCicle && this.currentCicle.from && this.currentCicle.to){
        domains.from = moment(this.currentCicle.from,"YYYY-MM-DD").format("YYYY-MM-DD")
        domains.to = moment(this.currentCicle.to,"YYYY-MM-DD").format("YYYY-MM-DD")
      }
      console.log("from", domains.from);
      console.log("to", domains.to);
      console.log("domains", this.selectedStore.url);
      const url = `kpis/whitelabel/`;
      this.$axios
        .post(url, domains)
        .then((response) => {
        const res = response.data.data[0];
        this.statsInfo = res
          console.log("ciclePlan", res);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    loadTabs() {
      if (!this.$route.params.tab) {
        this.tabs = 0;
      } else {
        if (this.$route.params.tab == "data") {
          this.tabs = 0;
        }
        if (this.$route.params.tab == "resource") {
          this.tabs = 1;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
